export enum ConfigModuleSchemaRoles{
  RESOURCE_IDENTIFIER =  'roles',
  ACTION_VIEW = 'view',
  ACTION_READ = 'read',
  ACTION_CREATE = 'create',
  ACTION_UPDATE = 'update',
  ACTION_DELETE = 'delete',
};
